import React, { useEffect, useRef, useState } from "react";
import {
  useTheme,
  CssBaseline,
  Box,
  Grid,
  Typography,
  Card,
  CardContent,
  TextField,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  Button,
  useMediaQuery,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Snackbar,
  Alert,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ShieldOutlinedIcon from "@mui/icons-material/ShieldOutlined";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import axios from "axios";
import {
  ApplicationType,
  date,
  entity_id,
  getGeolocation,
  location,
  locationGeo,
  orderID,
  Platform,
} from "../Utils/Const";
import { baseapi } from "../Environmentalurl";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import useIPAddress from "../Utils/useIPAddress";
import api from "../Utils/Api";

export default function Electricity() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const isDark = theme.palette.mode === "dark";
  const md = useMediaQuery("(min-width:900px)");

  const [electricityBoards, setElectricityBoards] = useState([]);
  const [selectedBoard, setSelectedBoard] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [billParams, setBillParams] = useState([]);
  const [paramValues, setParamValues] = useState({});
  const [billFetchEnabled, setBillFetchEnabled] = useState(false);
  const [billDetails, setBillDetails] = useState(null);
  const [tpinOpen, setTpinOpen] = useState(false);
  const [tpin, setTpin] = useState("");
  const [isVerifying, setIsVerifying] = useState(false);
  const [insufficientOpen, setInsufficientOpen] = useState(false);
  const [insufficientMsg, setInsufficientMsg] = useState("");
  const [successOpen, setSuccessOpen] = useState(false);
  // ── Charges summary ──────────────────────────────────────────────────────
  const [chargesLoading, setChargesLoading] = useState(false);
  const [chargesData, setChargesData] = useState(null);
  const [chargesOpen, setChargesOpen] = useState(false);

  // ── Payment result dialog ────────────────────────────────────────────────
  const [paymentResult, setPaymentResult] = useState({
    open: false,
    success: false,
    message: "",
  });
  const [openFetchDialog, setOpenFetchDialog] = useState(false);
  const [openPaymentDialog, setOpenPaymentDialog] = useState(false);
  const [paymentMessage, setPaymentMessage] = useState("");
  const ip = useIPAddress();
  const bbpsUrls = useSelector((state) => state.auth.bbpsUrls);
  const inputRefs = useRef([]);
  const electricityBoardsURL = bbpsUrls?.Electricity;

  // ── Toast state ──────────────────────────────────────────────────────────────
  const [toast, setToast] = useState({
    open: false,
    message: "",
    severity: "info", // "success" | "error" | "warning" | "info"
  });

  const showToast = (message, severity = "info") => {
    setToast({ open: true, message, severity });
  };

  const handleToastClose = (_, reason) => {
    if (reason === "clickaway") return;
    setToast((prev) => ({ ...prev, open: false }));
  };
  // ─────────────────────────────────────────────────────────────────────────────

  console.log(electricityBoardsURL);
  useEffect(() => {
    const fetchBoards = async () => {
      try {
        setLoading(true);
        const response = await api.post(`${baseapi}/getbbpsservices`, {
          url: electricityBoardsURL,
        });

        if (Array.isArray(response.data)) {
          setElectricityBoards(response.data);
          setError("");
        } else {
          setError("Invalid response format from server.");
        }
      } catch (err) {
        console.error("Error fetching boards:", err);
        setError("Failed to fetch electricity boards.");
      } finally {
        setLoading(false);
      }
    };

    fetchBoards();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ✅ When board changes → set params
  const handleBoardChange = (e) => {
    const value = e.target.value;
    setSelectedBoard(value);
    setChargesData(null);

    const board = electricityBoards.find((b) => b.Value === value);
    if (board) {
      setBillFetchEnabled(board.BillFetchEnabled);
      try {
        const parsed = JSON.parse(board.BBPSData);
        setBillParams(parsed);
      } catch (err) {
        console.error("Invalid BBPSData JSON:", err);
        setBillParams([]);
      }
    } else {
      setBillParams([]);
    }
  };

  const handleParamChange = (paramName, value) => {
    setParamValues((prev) => ({ ...prev, [paramName]: value }));
  };

  // ✅ Bill Fetch logic
  const handleFetchOrPay = async () => {
    if (!selectedBoard) {
      showToast("Please select a board!", "warning");
      return;
    }

    const board = electricityBoards.find((b) => b.Value === selectedBoard);
    if (!board) {
      showToast("Invalid board selected.", "error");
      return;
    }

    const Mobilenumber = JSON.parse(
      sessionStorage.getItem("mobileNumber") || "null",
    );
    const SessionID = JSON.parse(sessionStorage.getItem("SessionID") || "null");

    const Account_num = paramValues[billParams[0]?.paramName] || "";

    const Optional1 = billParams.map((p) => p.paramName);
    const Optional2 = billParams.map((p) => paramValues[p.paramName] || "");

    const payload = {
      ReqType: "Jan_Aadhaar_eWallet_BBPSPayments",
      MachineID: ip,
      Mobilenumber,
      SessionID,
      Date: date,
      OrderId: orderID,
      TPIN: "",
      RequestType: "BA_BBPS_Billfetch",
      Account_num: Mobilenumber,
      SpKey: board.Value,
      Amount: "1",
      Optional1,
      Optional2,
      Optional3: "true",
      Optional4: "",
      Optional5: "",
      Optional6: "",
      Optional7: "",
      Statement: "NOT_SUPPORTED",
      Narration: "",
      IsBillFetch: "",
      Platform: Platform,
      ApplicationType: ApplicationType,
      EntityID: entity_id,
      GeoLocation: locationGeo,
      ServiceID: "3",
      ParameterInfo: "",
    };

    console.log("📤 Sending Bill Fetch Request:", payload);

    try {
      const res = await api.post(
        `${baseapi}/JanAadhaareWalletBBPSPayments`,
        payload,
      );
      console.log("📥 Bill Fetch Response:", res.data);
      setBillDetails(res.data);

      if (
        res.data.Response_Code === "2001" ||
        res.data.Message?.includes("Insufficient")
      ) {
        setInsufficientMsg(res.data.Message || "Insufficient Wallet Balance");
        setInsufficientOpen(true);
        return;
      }

      if (res.data.Response_Code === "1000") {
        sessionStorage.setItem("orderID", res.data.OrderId);

        sessionStorage.setItem(
          "billFetchData",
          JSON.stringify({
            Mobilenumber,
            SessionID,
            orderID: res.data.OrderId,
            Account_num: Mobilenumber,
            CustomerID: Mobilenumber,
            SpKey: board.Value,
            Optional1,
            Optional2,
            billerResponseInfo: res.data.billerResponseInfo,
            billAmount: res.data.billAmount,
            billerName: res.data.billerName,
            customerName: res.data.customerName,
            dueDate: res.data.dueDate,
          }),
        );

        setOpenFetchDialog(true);
      } else {
        showToast(res.data.Message || "Something went wrong.", "warning");
      }
    } catch (error) {
      console.error("❌ Error in bill fetch:", error);
      showToast("Failed to fetch bill. Please try again.", "error");
    }
  };

  // ✅ Bill Payment function
  // ── Bill → GetCharges → show summary ──────────────────────────────────────
  const handleBillPayment = async () => {
    setOpenFetchDialog(false);
    setChargesLoading(true);
    const mobile = JSON.parse(sessionStorage.getItem("mobileNumber"));
    const session = JSON.parse(sessionStorage.getItem("SessionID"));
    const stored = JSON.parse(sessionStorage.getItem("billFetchData") || "{}");
    try {
      const chargesRes = await api.post(`${baseapi}/getbbpscharges`, {
        ReqType: "TA_BBPS_GetCharges",
        TrxnAmount: String(stored.billAmount || "0"),
        BillerID: selectedBoard,
        EntityID: entity_id,
        MachineID: ip,
        ApplicationType: ApplicationType,
        Platform: Platform,
        GeoLocation: locationGeo,
        SessionID: session,
        Mobilenumber: mobile,
        ServiceID: "3",
      });
      const resData = chargesRes.data;
      if (resData?.Response_Code !== "1000" || !resData?.TotalPayable) {
        alert(resData?.Message || "Unable to calculate charges. Please try again.");
        return;
      }
      setChargesData(resData);
      setChargesOpen(true);
    } catch {
      alert("Unable to calculate charges. Please try again.");
    } finally {
      setChargesLoading(false);
    }
  };

  // ── Charges confirmed → check wallet balance ──────────────────────────────
  const handleConfirmCharges = () => {
    setChargesOpen(false);
    validateBalanceAndProceed();
  };

  // ── Balance check (runs after GetCharges, before TPIN) ─────────────────────
  const validateBalanceAndProceed = async () => {
    try {
      const mobile = JSON.parse(sessionStorage.getItem("mobileNumber") || "null");
      const session = JSON.parse(sessionStorage.getItem("SessionID") || "null");
      const stored = JSON.parse(sessionStorage.getItem("billFetchData") || "{}");

      const requestBody = {
        ApplicationType: ApplicationType,
        EntityID: entity_id,
        GeoLocation: locationGeo,
        Mobilenumber: mobile,
        Platform: Platform,
        WalletTypeID: "1",
        ReqType: "Jan_Aadhaar_eWallet_Statement",
        SessionID: session,
        MachineID: ip,
        FromDate: "",
        ToDate: "",
      };

      const response = await api.post(
        `${baseapi}/JanAadhaareWalletStatement`,
        requestBody,
      );

      const { Info } = response.data;
      if (!Info || Info.length === 0) {
        showToast("Unable to read wallet info.", "error");
        return;
      }

      const walletBalance = parseFloat(Info[0].Balance);
      const rechargeAmount = parseFloat(
        chargesData?.TotalPayable ?? stored?.billAmount ?? 0,
      );

      if (walletBalance < rechargeAmount) {
        setInsufficientMsg(
          `Insufficient wallet balance. Amount payable is ₹${rechargeAmount}, but your wallet balance is ₹${walletBalance}.`,
        );
        setInsufficientOpen(true);
        return;
      }

      setTpin("");
      setTpinOpen(true);
    } catch (error) {
      showToast("Unable to check wallet balance!", "error");
    }
  };

  const verifyTPIN = async () => {
    if (!tpin || tpin.length !== 4) {
      showToast("Please enter a valid 4-digit TPIN.", "warning");
      return;
    }

    setIsVerifying(true);

    const mobileNumber = sessionStorage.getItem("mobileNumber");

    const tpinBody = {
      ReqType: "MT_TPIN_Management",
      Mobilenumber: mobileNumber,
      Statement: "ValidateTPIN",
      TPIN: tpin,
      OldTPIN: "",
      Platform: Platform,
      EntityID: entity_id,
      GeoLocation: locationGeo,
      MachineID: ip,
    };

    try {
      const tpinRes = await api.post(`${baseapi}/tpin`, tpinBody);
      console.log("TPIN RESPONSE:", tpinRes.data);

      if (tpinRes.data.Response_Code === "1692") {
        setTpinOpen(false);
        await processFinalBillPayment();
      } else {
        showToast(tpinRes.data.Message || "Invalid TPIN.", "error");
      }
    } catch (err) {
      console.error("TPIN error:", err);
      showToast("Server error in verifying TPIN.", "error");
    } finally {
      setIsVerifying(false);
    }
  };

  const processFinalBillPayment = async () => {
    const storedData = JSON.parse(
      sessionStorage.getItem("billFetchData") || "{}",
    );
    const storedOrderId = sessionStorage.getItem("orderID");

    // ⚠️ Send the RAW base amount here, not chargesData.TotalPayable.
    // The payment API applies its own charges/GST on top of whatever
    // Amount it receives — sending it the already-charges-inclusive
    // TotalPayable causes it to add charges a second time, over-debiting
    // the wallet. TotalPayable is only for display and the balance check.
    const payableAmount = storedData?.billAmount;

    const payload = {
      ReqType: "Jan_Aadhaar_eWallet_BBPSPayments",
      MachineID: ip,
      Mobilenumber: storedData.Mobilenumber,
      SessionID: storedData.SessionID,
      Date: date,
      OrderId: storedOrderId,
      TPIN: tpin,
      RequestType: "BA_BBPS_PAYMENT",
      ParameterInfo: "Electricity Bill Payment",
      IsExternalTransaction: "1",
      Account_num: storedData.Mobilenumber,
      CustomerID: storedData.Mobilenumber,
      SpKey: storedData.SpKey,
      Amount: payableAmount,
      Optional1: storedData.Optional1,
      Optional2: storedData.Optional2,
      Optional3: "true",
      Optional4: storedData.billerResponseInfo,
      Optional6: "NOT_SUPPORTED",
      Optional7: "",
      Platform: Platform,
      ApplicationType: ApplicationType,
      EntityID: entity_id,
      GeoLocation: locationGeo,
      Statement: "ProcessDebit",
      ServiceID: "3",
      Narration: `Payment of Rs. ${payableAmount} to Electricity Bill`,
    };

    try {
      const payRes = await api.post(
        `${baseapi}/JanAadhaareWalletBBPSPayments`,
        payload,
      );
      console.log("PAYMENT RESPONSE:", payRes.data);

      if (payRes.data.Response_Code === "1000") {
        setPaymentResult({ open: true, success: true, message: "" });
        setTimeout(() => {
          window.location.href = "/dashboard";
        }, 1500);
      } else if (
        payRes.data.Response_Code === "2001" ||
        (payRes.data.Message || "").toLowerCase().includes("insufficient")
      ) {
        setInsufficientMsg(payRes.data.Message || "Insufficient Wallet Balance");
        setInsufficientOpen(true);
      } else {
        showToast(payRes.data.Message || "Payment failed.", "error");
      }
    } catch (error) {
      console.error("Payment error:", error);
      showToast("Server error during payment.", "error");
    }
  };

  const navigate = useNavigate();

  return (
    <>
      <CssBaseline />
      <Box
        sx={{
          background: "#f8fafc",
          px: { xs: 2, md: 6 },
          transition: "background 0.4s ease",
        }}
      >
        <Grid container spacing={3}>
          {/* Left Card */}
          <Grid size={{ xs: 12, md: 4 }} item xs={12} md={4}>
            <Card
              elevation={isDark ? 0 : 2}
              sx={{
                background: "white",
                borderRadius: 3,
                p: 2,
                boxShadow: "0 4px 12px rgba(0,0,0,0.04)",
                transition: "all 0.3s ease",
                border: "1px solid #f0f0f0",
              }}
            >
              <CardContent>
                <Typography
                  variant="h5"
                  sx={{
                    color: theme.palette.primary.main,
                    fontWeight: 700,
                    mb: 1,
                    fontSize: { xs: 15 },
                  }}
                >
                  Pay Electricity Bill
                </Typography>

                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ mb: { md: 2 }, mt: { md: 2 } }}
                >
                  Select Your Electricity Board
                </Typography>

                <FormControl fullWidth variant="filled" sx={{ mb: 3 }}>
                  <InputLabel>Select Board</InputLabel>
                  <Select
                    value={selectedBoard}
                    onChange={handleBoardChange}
                    sx={{
                      backgroundColor: "#f8fafc",
                      borderRadius: 1,
                    }}
                  >
                    {loading ? (
                      <MenuItem disabled>Loading...</MenuItem>
                    ) : error ? (
                      <MenuItem disabled>{error}</MenuItem>
                    ) : electricityBoards.length > 0 ? (
                      electricityBoards.map((board, index) => (
                        <MenuItem key={index} value={board.Value}>
                          {board.Text}
                        </MenuItem>
                      ))
                    ) : (
                      <MenuItem disabled>No boards available</MenuItem>
                    )}
                  </Select>
                </FormControl>

                {billParams.map((param, index) => (
                  <Box key={index} sx={{ mb: 2 }}>
                    <Typography variant="caption" color="text.secondary">
                      {param.paramName}
                    </Typography>
                    <TextField
                      fullWidth
                      autoComplete="off"
                      variant="filled"
                      placeholder={`Enter ${param.paramName}`}
                      value={paramValues[param.paramName] || ""}
                      onChange={(e) =>
                        handleParamChange(param.paramName, e.target.value)
                      }
                      sx={{
                        mt: 1,
                        backgroundColor: "#f8fafc",
                        borderRadius: 1,
                      }}
                    />
                  </Box>
                ))}

                {selectedBoard && (
                  <Button
                    fullWidth
                    size="large"
                    endIcon={<ArrowForwardIcon />}
                    onClick={handleFetchOrPay}
                    sx={{
                      background: "linear-gradient(135deg, #16a34a, #22c55e)",
                      color: "#fff",
                      borderRadius: 2,
                      py: 1.2,
                      fontWeight: 700,
                      textTransform: "none",
                      "&:hover": { filter: "brightness(1.05)" },
                    }}
                  >
                    {billFetchEnabled ? "Fetch Bill" : "Pay Now"}
                  </Button>
                )}

                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    mt: 3,
                    color: "text.secondary",
                    mb: 4,
                  }}
                >
                  <ShieldOutlinedIcon
                    sx={{ color: theme.palette.primary.main }}
                  />
                  <Typography variant="body2">
                    100% Secure & Instant Bill Fetch
                  </Typography>
                </Box>
              </CardContent>
            </Card>
          </Grid>

          {/* Right Card */}
          {!isMobile && (
            <>
              <Grid size={{ xs: 12, md: 8 }} item xs={12} md={8}>
                <Card
                  elevation={isDark ? 0 : 2}
                  sx={{
                    background: "white",
                    borderRadius: 3,
                    p: 2,
                    boxShadow: "0 4px 12px rgba(0,0,0,0.04)",
                    height: "100%",
                    transition: "all 0.3s ease",
                    border: "1px solid #f0f0f0",
                  }}
                >
                  <CardContent>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <Box
                        sx={{
                          width: 36,
                          height: 36,
                          borderRadius: 1.5,
                          background: isDark
                            ? "rgba(35,190,165,0.12)"
                            : "rgba(0,123,255,0.12)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: theme.palette.primary.main,
                          mr: 1,
                        }}
                      >
                        <SearchIcon />
                      </Box>
                      <Typography
                        variant="h6"
                        sx={{ color: "text.primary", fontWeight: 700 }}
                      >
                        Browse Plans
                      </Typography>
                    </Box>

                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{ mt: 1 }}
                    >
                      Select an operator to see available plans
                    </Typography>

                    <Box
                      sx={{
                        background: isDark ? "#12303a" : "rgba(0,0,0,0.05)",
                        borderRadius: 2,
                        p: 3,
                        color: "text.secondary",
                        mt: 1,
                        mb: 2,
                        minHeight: 92,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Typography>No plans available.</Typography>
                    </Box>

                    <Box
                      sx={{
                        background: isDark ? "#0f3a35" : "rgba(0,123,255,0.05)",
                        borderRadius: 1.5,
                        p: 1.2,
                        color: "text.secondary",
                        mt: 1,
                      }}
                    >
                      <Typography
                        sx={{
                          fontWeight: 600,
                          color: theme.palette.primary.main,
                        }}
                      >
                        Disclaimer:
                      </Typography>
                      <Typography variant="body2" sx={{ mt: 0.5 }}>
                        While we support most recharges, please verify with your
                        operator before proceeding.
                      </Typography>
                    </Box>
                  </CardContent>
                </Card>
              </Grid>

              {/* Trusted Section */}
              <Grid size={{ xs: 12 }} item xs={12}>
                <Box
                  sx={{
                    borderRadius: md ? 2 : 0,
                    p: 1.5,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Typography color="text.secondary">
                    Trusted by <b>UIDAI BBPS Network</b>
                  </Typography>
                </Box>
              </Grid>
            </>
          )}
        </Grid>
      </Box>

      {/* ✅ Bill Fetch Dialog */}
      <Dialog open={openFetchDialog} onClose={() => setOpenFetchDialog(false)}>
        <DialogTitle>Bill Details</DialogTitle>
        <DialogContent>
          <Typography>
            <b>Customer Name:</b> {billDetails?.customerName}
          </Typography>
          <Typography>
            <b>Biller Name:</b> {billDetails?.billerName}
          </Typography>
          <Typography>
            <b>Due Date:</b> {billDetails?.dueDate}
          </Typography>
          <Typography>
            <b>Amount:</b> ₹{billDetails?.billAmount}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenFetchDialog(false)}>Close</Button>
          <Button
            variant="contained"
            onClick={handleBillPayment}
            disabled={chargesLoading}
            sx={{
              background: "linear-gradient(90deg, #007BFF 0%, #00C9A7 100%)",
              color: "#fff",
            }}
          >
            {chargesLoading ? "Calculating charges..." : "Pay Now"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* ✅ Insufficient Balance Dialog */}
      <Dialog
        open={insufficientOpen}
        onClose={() => setInsufficientOpen(false)}
        PaperProps={{
          sx: { borderRadius: 3, p: 1, width: 380 },
        }}
      >
        <DialogTitle sx={{ textAlign: "center", fontWeight: 600, fontSize: 18, pb: 0.5 }}>
          ⚠️ Insufficient Balance
        </DialogTitle>
        <DialogContent sx={{ textAlign: "center", mt: 1 }}>
          <Typography sx={{ color: "text.secondary", fontSize: 14 }}>
            {insufficientMsg}
          </Typography>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button
            onClick={() => setInsufficientOpen(false)}
            fullWidth
            variant="outlined"
            sx={{ borderRadius: 2, textTransform: "none", fontWeight: 500 }}
          >
            Cancel
          </Button>
          <Button
            fullWidth
            variant="contained"
            onClick={() => {
              setInsufficientOpen(false);
              navigate("/dashboard/loadmoney");
            }}
            sx={{
              borderRadius: 2,
              textTransform: "none",
              fontWeight: 600,
              ml: 1,
              color: "white",
            }}
          >
            Load Money
          </Button>
        </DialogActions>
      </Dialog>

      {/* ✅ TPIN Dialog */}
      <Dialog
        open={tpinOpen}
        onClose={() => setTpinOpen(false)}
        PaperProps={{
          sx: {
            borderRadius: "16px",
            padding: "6px",
            width: "380px",
            backgroundColor: isDark ? "#1d2633" : "#fefefe",
            boxShadow: "0 8px 28px rgba(0,0,0,0.18)",
          },
        }}
      >
        <DialogTitle
          sx={{
            fontWeight: "bold",
            fontSize: "20px",
            textAlign: "center",
            color: isDark ? "#fff" : "#114c28",
            pb: 1,
          }}
        >
          🔐 Enter TPIN
        </DialogTitle>

        <DialogContent
          sx={{
            px: 4,
            pb: 1,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Box sx={{ display: "flex", gap: 1.5, justifyContent: "center" }}>
            {[0, 1, 2, 3].map((index) => (
              <TextField
                key={index}
                type="password"
                value={tpin[index] || ""}
                inputRef={(el) => (inputRefs.current[index] = el)}
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, "").slice(-1);
                  const newTpin = tpin.padEnd(4, "").split("");
                  newTpin[index] = value;
                  setTpin(newTpin.join(""));
                  if (value && index < 3) {
                    inputRefs.current[index + 1]?.focus();
                  }
                }}
                onKeyDown={(e) => {
                  if (e.key === "Backspace" && !tpin[index] && index > 0) {
                    inputRefs.current[index - 1]?.focus();
                  }
                }}
                inputProps={{
                  maxLength: 1,
                  style: { textAlign: "center", fontSize: "22px", fontWeight: 600 },
                }}
                sx={{
                  width: 60,
                  "& .MuiOutlinedInput-root": { height: 60, borderRadius: 3 },
                }}
              />
            ))}
          </Box>
        </DialogContent>

        <DialogActions
          sx={{ px: 3, pb: 2, display: "flex", justifyContent: "space-between" }}
        >
          <Button
            onClick={() => setTpinOpen(false)}
            sx={{ textTransform: "none", fontWeight: 600, borderRadius: "10px", px: 3 }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            disabled={isVerifying}
            onClick={verifyTPIN}
            sx={{
              backgroundColor: "#114c28",
              color: "white",
              textTransform: "none",
              fontWeight: "bold",
              borderRadius: "10px",
              px: 4,
              "&:hover": { backgroundColor: "#0d3d20" },
            }}
          >
            {isVerifying ? "Verifying..." : "Verify"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* ✅ Payment Success Dialog */}
      <Dialog open={successOpen}>
        <DialogTitle>🎉 Payment Successful!</DialogTitle>
        <DialogContent>
          <Typography>Your electricity bill has been paid successfully.</Typography>
        </DialogContent>
      </Dialog>

      {/* ✅ Toast Snackbar */}
      <Snackbar
        open={toast.open}
        autoHideDuration={3500}
        onClose={handleToastClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={handleToastClose}
          severity={toast.severity}
          variant="filled"
          sx={{ width: "100%", borderRadius: 2 }}
        >
          {toast.message}
        </Alert>
      </Snackbar>

      {/* ── CHARGES SUMMARY DIALOG ──────────────────────────────── */}
      <Dialog
        open={chargesOpen}
        onClose={() => setChargesOpen(false)}
        maxWidth="xs"
        fullWidth
        PaperProps={{ sx: { borderRadius: "20px", overflow: "hidden", boxShadow: "0 24px 60px rgba(0,0,0,0.18)" } }}
      >
        <Box sx={{ background: "linear-gradient(90deg, #007BFF 0%, #00C9A7 100%)", py: 3, display: "flex", flexDirection: "column", alignItems: "center", gap: 0.5, position: "relative", overflow: "hidden" }}>
          <Box sx={{ position: "absolute", top: -20, right: -20, width: 80, height: 80, borderRadius: "50%", background: "rgba(255,255,255,0.08)" }} />
          <Typography sx={{ color: "#fff", fontWeight: 700, fontSize: 18 }}>Payment Summary</Typography>
          <Typography sx={{ color: "rgba(255,255,255,0.8)", fontSize: 12 }}>Review charges before proceeding</Typography>
        </Box>
        <DialogContent sx={{ px: 3, pt: 2.5, pb: 1 }}>
          {chargesData && (
            <Box sx={{ bgcolor: "#f5f7fb", borderRadius: 2, p: 2 }}>
              <Box display="flex" justifyContent="space-between" mb={1.2}>
                <Typography color="text.secondary" fontSize={14}>Transaction Amount</Typography>
                <Typography fontWeight={600}>₹{chargesData.TransactionAmount}</Typography>
              </Box>
              <Box display="flex" justifyContent="space-between" mb={1.2}>
                <Typography color="text.secondary" fontSize={14}>Charges</Typography>
                <Typography fontWeight={600}>₹{chargesData.Charges}</Typography>
              </Box>
              <Box display="flex" justifyContent="space-between" mb={1.2} pb={1.5} sx={{ borderBottom: "1px dashed #ccc" }}>
                <Typography color="text.secondary" fontSize={14}>GST</Typography>
                <Typography fontWeight={600}>₹{chargesData.GST}</Typography>
              </Box>
              <Box display="flex" justifyContent="space-between" mt={1.5}>
                <Typography fontWeight={700} fontSize={16}>Total Payable</Typography>
                <Typography fontWeight={700} fontSize={16} sx={{ color: "#007BFF" }}>₹{chargesData.TotalPayable}</Typography>
              </Box>
            </Box>
          )}
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 3, pt: 1, gap: 1 }}>
          <Button onClick={() => setChargesOpen(false)} sx={{ textTransform: "none", borderRadius: 2 }}>Cancel</Button>
          <Button variant="contained" fullWidth size="large" onClick={handleConfirmCharges}
            sx={{ textTransform: "none", borderRadius: 2, fontWeight: 700, background: "linear-gradient(90deg, #007BFF 0%, #00C9A7 100%)", boxShadow: "0 6px 16px rgba(0,123,255,0.3)" }}>
            Pay Now ₹{chargesData?.TotalPayable}
          </Button>
        </DialogActions>
      </Dialog>

      {/* ── PAYMENT RESULT DIALOG ───────────────────────────────── */}
      <Dialog
        open={paymentResult.open}
        onClose={() => setPaymentResult({ ...paymentResult, open: false })}
        maxWidth="xs"
        fullWidth
        PaperProps={{ sx: { borderRadius: "20px", overflow: "hidden", boxShadow: "0 24px 60px rgba(0,0,0,0.18)" } }}
      >
        <Box sx={{ background: paymentResult.success ? "linear-gradient(135deg, #16a34a, #22c55e)" : "linear-gradient(135deg, #dc2626, #b91c1c)", py: 3.5, display: "flex", flexDirection: "column", alignItems: "center", gap: 1 }}>
          <Typography sx={{ fontSize: 40 }}>{paymentResult.success ? "🎉" : "❌"}</Typography>
          <Typography sx={{ color: "#fff", fontWeight: 700, fontSize: 18 }}>{paymentResult.success ? "Payment Successful!" : "Payment Failed"}</Typography>
        </Box>
        <DialogContent sx={{ px: 3, pt: 2.5, pb: 1, textAlign: "center" }}>
          <Typography sx={{ fontSize: 14, color: "text.secondary", lineHeight: 1.6 }}>
            {paymentResult.success ? "Your bill has been paid successfully." : paymentResult.message}
          </Typography>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 3, pt: 1 }}>
          <Button variant="contained" fullWidth size="large"
            onClick={() => { setPaymentResult({ ...paymentResult, open: false }); if (paymentResult.success) window.location.href = "/dashboard"; }}
            sx={{ textTransform: "none", borderRadius: 2, fontWeight: 700, fontSize: 14,
              background: paymentResult.success ? "linear-gradient(135deg, #16a34a, #22c55e)" : "linear-gradient(135deg, #dc2626, #b91c1c)",
              boxShadow: paymentResult.success ? "0 4px 14px rgba(22,163,74,0.35)" : "0 4px 14px rgba(220,38,38,0.35)" }}>
            {paymentResult.success ? "Back to Dashboard" : "Try Again"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}